import styled from '@emotion/styled'

import {cssTheme} from '../../../themes'

/**
 * Applies the standard title typography (titleM) to a NavBar's `centerContent`.
 * NavBar itself is typography-neutral (it also hosts search boxes), so title-bar
 * use cases — e.g. modal headers replacing the legacy `TitleBar` — wrap their
 * title node with this helper.
 */
export const NavBarTitle = styled.div`
  ${cssTheme.typography.titleM};
  text-align: center;
`
